import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { OptionFormGroup } from '@/App/tiles/Option/fields/OptionFormGroup.tsx';
import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useCheckOption } from '@/App/tiles/Option/QueueContext.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { selectOptionLegsValidation } from '@/store/option/selectors/optionSelectors.ts';
import type { LegId, OptionBarrier } from '@/store/option/state.ts';

type TriggerEndDateProps = {
  tileId: string;
  barrier: OptionBarrier;
  numberOfBarrier?: number;
};

export function TriggerEndDate({ tileId, barrier, numberOfBarrier = 1 }: TriggerEndDateProps) {
  const [checkOption] = useCheckOption();
  const legId: LegId = `${tileId}/0`;

  const { barrierValidation } = useOptionSelector((option) => {
    const validation = selectOptionLegsValidation(option, legId);
    const barrier = numberOfBarrier === 1 ? validation?.barrier1 : validation?.barrier2;
    return { barrierValidation: barrier?.endDate };
  });

  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleBarrierEndDateSelected = (dateOrTenor: string) => {
    sgwtWebAnalytics?.trackEvent('Option', 'Trigger End date selected', dateOrTenor);

    checkOption({
      tileId,
      legProperties: {
        legId,
        [`barrier${numberOfBarrier}`]: {
          endDate: dateOrTenor,
        },
      },
    });
  };

  return (
    <OptionFormGroup label={<FormattedMessage id="option.fields.triggerEndDate" />}>
      <TradeCaptureValidationWrapper validation={barrierValidation}>
        <DatePickerWithTenorNext
          data-e2e={`trigger-${numberOfBarrier}-date`}
          date={barrier.endDate}
          onChange={handleBarrierEndDateSelected}
        />
      </TradeCaptureValidationWrapper>
    </OptionFormGroup>
  );
}
